import React, { use, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Card,
  Fade,
  Grid,
  Table,
  Paper,
  Button,
  Tooltip,
  InputBase,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  CardContent,
  CardActions,
  TableContainer,
  TablePagination,
  tableCellClasses,
} from "@mui/material";
import _ from 'lodash';
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import AddNewStudy from "../offcanvas/AddNewStudy";
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Search, Folder, EditNote } from "@mui/icons-material";
import SnackBarMessage from "../../components/SnackBarMessage";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { getStudies, dropOne, searchItem, getStatus } from "../repositories/StudyTypeRepository";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EC7BA1",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  " &:first-child tr, &:first-child": {
    borderTopLeftRadius: "50px",
  },
  " &:first-child tr, &:last-child": {
    borderTopRightRadius: "50px",
  },
  " &:last-child tr, &:first-child": {
    borderBottomLeftRadius: "50px",
  },
  " &:last-child tr, &:last-child": {
    borderBottomRightRadius: "50px",
  },
}));

const CommonStudyTypesEvents = () => {
  const navigate = useNavigate();
  const [add, setAdd] = useState();
  const [name, setName] = useState();
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState();
  const [isEditing, setIsEditing] = useState();
  const [selected, setSelected] = useState(null);
  const [deleteItem, setDeleteItem] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [studiesList, setStudiesList] = useState([]);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [snackSeverity, setSnackSeverity] = useState("success");
  
  const closeDialog = () => {
    setOpenDelete(false);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - studiesList.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseCanvas = () => {
    setOpenCanvas(false);
    setName("");
    setStatus("");
    setSelected(null);
    setIsEditing(false);
  };

  const onlyClose = () => {
    setOpenCanvas(false);
  }

  useEffect(() => {
    getData();
    getStatusData();
  }, []);

  const getData = async () => {
    const response = await getStudies();
    if (response) {
      if (response.status === "Ok") {
        setStudiesList(response.content);
      } else if (response.status === "401") {
        setStudiesList([]);
        navigate(`../error401`);
      } else {
        setStudiesList([]);
      }
    }
  }

  const getStatusData = async () => {
    const response = await getStatus();
    if (response) {
      if (response.status === "Ok") {
        setStatusList(response.content);
      } else if (response.status === "401") {
        setStatusList([]);
        navigate(`../error401`);
      }else{
        setStudiesList([])
      }
    }
  }

  const handleDelete = async () => {
    const response = await dropOne(deleteItem);
    if (response.status === "Ok") {
      setSnackSeverity("success");
      setSnackMessage("Se eliminó correctamente");
      setSnackOpen(true);
      getData();
    } else {
      setSnackSeverity("error");
      setSnackMessage("No se pudo eliminar");
      setSnackOpen(true);
    }
  };

  const debouncedSearch = _.debounce(async (searchTerm) => {
    const response = await searchItem(searchTerm);
    if (response) {
      if (response.status === "Ok") {
        setStudiesList(response.content);
      } else if (response.status === "401") {
        setStudiesList([]);
        navigate(`../error401`);
      } else {
        setStudiesList([]);
      }
    }
  }, 800, { leading: true });

  useEffect(() => {
    if (searchTerm === "" || searchTerm === undefined || searchTerm.length === 0) {
      getData();
    } else if (searchTerm.length >= 3) {
      setPage(0);
      debouncedSearch(searchTerm);
      debouncedSearch.cancel();
    }
    getStatusData();
  }, [searchTerm]);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };
  return (
    <div>
      <div id="div-style-8">
        <Folder color={"primary"} fontSize="large" id="icon-style-1" />
        <h2>Estudios</h2>
      </div>
      <Card id="card-style-2">
        <CardContent>
          <Grid container spacing={2} id="grid-style-2">
            <Grid xl={6} lg={8} md={10} sm={12} xs={12}>
              <Paper component="form" id="paper-style-2">
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Buscar..."
                  inputProps={{ "aria-label": "search google maps" }}
                  value={searchTerm}
                  onChange={handleInputChange}
                />
                <IconButton type="button" id="icon-style-2" aria-label="search">
                  <Search color="primary" />
                </IconButton>
              </Paper>
            </Grid>
            <Grid xl={6} lg={4} md={2} sm={12} xs={12} id="grid-style-3">
              <Button
                component="label"
                onClick={() => {
                  setStatus("");
                  setOpenCanvas(true)
                  setName("");
                  setSelected(null);
                  setIsEditing(false)
                  setAdd(true)
                }}
                variant="contained"
                color="secondary"
                size="small"
                id="button-style-3"
                style={{ marginRight: "5px" }}
              >
                <AddIcon /> Agregar
              </Button>
            </Grid>
          </Grid>
          <Grid>
            <TableContainer id="table-container-style-1">
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">No.</StyledTableCell>
                    <StyledTableCell align="center">Estudio</StyledTableCell>
                    <StyledTableCell align="center">Estatus</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {studiesList.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        Sin registros
                      </TableCell>
                    </TableRow>
                  ) : (
                    studiesList
                      .slice(
                        page * rowsPerPage, page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <StyledTableRow key={row.id}>
                            <StyledTableCell align="center">
                              {page * rowsPerPage + index + 1}
                            </StyledTableCell>
                            <StyledTableCell align="center">{`${row?.name} `}</StyledTableCell>
                            <StyledTableCell align="center">
                              {row?.status}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Tooltip
                                title="Ver"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 600 }}
                                arrow
                              >
                                <IconButton
                                  aria-label="view"
                                  size="small"
                                  color="primary"
                                  onClick={() => {
                                    setName(row.name)
                                    setStatus(row.status)
                                    setSelected(row)
                                    setOpenCanvas(true)
                                    setIsEditing(true)
                                    setAdd(true)
                                  }}
                                >
                                  <VisibilityIcon fontSize="medium" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Editar"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 600 }}
                                arrow
                              >
                                <IconButton
                                  aria-label="edit"
                                  size="small"
                                  color="secondary"
                                  onClick={() => {
                                    setName(row.name)
                                    setStatus(row.status)
                                    setSelected(row)
                                    setOpenCanvas(true)
                                    setIsEditing(false)
                                    setAdd(false)
                                  }}
                                >
                                  <EditNote fontSize="medium" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Eliminar"
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 600 }}
                                arrow
                              >
                                <IconButton
                                  aria-label="delete"
                                  size="small"
                                  color="error"
                                  onClick={async () => {
                                    setOpenDelete(true);
                                    setDeleteItem(row._id);
                                  }}
                                >
                                  <DeleteIcon fontSize="medium" />
                                </IconButton>
                              </Tooltip>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                  )}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </CardContent>
        <CardActions>
          <SnackBarMessage
            severity={snackSeverity}
            message={snackMessage}
            open={snackOpen}
            onClose={() => {
              setSnackOpen(false);
            }}
          />
          <ConfirmationDialog
            title={"Eliminar registro"}
            message={
              "¿Estás seguro que deseas eliminar este estudio?"
            }
            openDialog={openDelete}
            closeDialog={closeDialog}
            executeAction={handleDelete}
          />
          <AddNewStudy
            openCanvas={openCanvas}
            name={name}
            status={status}
            onlyClose={onlyClose}
            item={selected}
            isEditing={isEditing}
            add={add}
            onClose={handleCloseCanvas}
            updateData={getData}
            statusData={statusList}
          />
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={studiesList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Resultados por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          />
        </CardActions>
      </Card>
    </div>
  );
};

export default CommonStudyTypesEvents;
